import React, { useEffect, useState, useRef } from "react";
import { Form, Button, Row, Col, Card } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import logo from "../images/shooraLogo.jpg";
import axios from "axios";

// Utility to extract dependent indexes from initialData
const getInitialDependentIndexes = (data) => {
  const indexes = new Set();
  Object.keys(data).forEach((key) => {
    const match = key.match(/depName(\d+)/);
    if (match) indexes.add(Number(match[1]));
  });
  return indexes.size > 0 ? [...indexes].sort((a, b) => a - b) : [0];
};

function InvestorForm({ initialData = {} }) {
  const formRef = useRef(null);
  const [formData, setFormData] = useState(initialData);
  const [dependents, setDependents] = useState(
    getInitialDependentIndexes(initialData)
  );
  const [dependentAdded, setDependentAdded] = useState(false);
  const [removedDependents, setRemovedDependents] = useState([]);
  const [updatedDependents, setUpdatedDependents] = useState([]);
  const [addedDependants, setAddedDependants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [investorData, setInvestorData] = useState(null);




  useEffect(() => {
    const fetchInvestorProfile = async () => {
      const inviteCodeId = sessionStorage.getItem("invitationCodeId");
      if (!inviteCodeId) return;

      try {
        const response = await axios.get(
          `https://apiv1.worknotion.com/investorsProgram/getInvestorProfileByInvitationId?invitationCodeId=${inviteCodeId}`
        );
        setInvestorData([]);
      } catch (error) {
        console.error("Error fetching investor profile:", error);
      }
    };

    fetchInvestorProfile();
  }, []);


  useEffect(() => {
    console.log(updatedDependents, "ddddddddddddddddddd");
  }, [updatedDependents]);

  const handleChange = (field, value, index) => {
    console.log(field, index, addedDependants, "aaaaaaaaaaaaaaaaa");

    if (formData.submitted == "false") return; // Prevent updates if form is already submitted
    if (value != formData[field] && field.includes("dep")) {
      if (!updatedDependents.includes(index)) {
        setUpdatedDependents((prev) => {
          return [...prev, index];
        });
      }
    }
    setFormData({ ...formData, [field]: value });
  };



  const handleGenerateStyledPDF = async () => {
    if (!investorData) return;
  
    const pdf = new jsPDF();
    const pageHeight = pdf.internal.pageSize.getHeight();
    let y = 20;
    const lineHeight = 10;
  
    // Load logo image as base64
    const getImageBase64 = (url) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          canvas.getContext("2d").drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        };
        img.src = url;
      });
    };
  
    const logoBase64 = await getImageBase64(logo);

    
    pdf.addImage(logoBase64, "PNG", 18, 8, 38, 15);
    y = 30; // Adjust Y after logo
  
    const checkPageBreak = () => {
      if (y + lineHeight > pageHeight) {
        pdf.addPage();
        y = 20;
      }
    };
  
    const addText = (text, isBold = false, spacing = 0) => {
      checkPageBreak();
      if (spacing) y += spacing;
      if (isBold) pdf.setFont(undefined, "bold");
      else pdf.setFont(undefined, "normal");
      pdf.text(text, 20, y);
      y += lineHeight;
    };
  
    const drawLine = (space = 5) => {
      checkPageBreak();
      y += space;
      pdf.setDrawColor(150);
      pdf.line(20, y, 190, y);
      y += space;
    };
  
    const {
      fullLegalName,
      dateOfBirth,
      countryOfBirth,
      countryOfCitizenship,
      immigrationStatus,
      passportNumber,
      investmentAmount,
      dependents = [],
      sourceOfFunds = [],
      additionalNote,
    } = investorData;
  
    pdf.setFontSize(16);
    addText("EB-5 Investor Intake Questionnaire", true, 5);
    drawLine();
  
    pdf.setFontSize(12);
    addText("Section 1: Principal Applicant Information", true, 5);
    addText(`Full Legal Name: ${fullLegalName || ""}`);
    addText(`Date of Birth: ${dateOfBirth || ""}`);
    addText(`Country of Birth: ${countryOfBirth || ""}`);
    addText(`Country of Citizenship: ${countryOfCitizenship || ""}`);
    addText(`Current Immigration Status (if in the U.S.): ${immigrationStatus || ""}`);
    addText(`Passport Number: ${passportNumber || ""}`);
    drawLine();
  
    addText("Section 2: Dependents Information", true, 5);
    pdf.setFont(undefined, "bold");
    pdf.text("Full Name", 20, y);
    pdf.text("Relationship", 60, y);
    pdf.text("DOB", 100, y);
    pdf.text("Birth Country", 130, y);
    pdf.text("Citizenship", 165, y);
    y += lineHeight;
  
    pdf.setFont(undefined, "normal");
    dependents.forEach((dep) => {
      checkPageBreak();
      pdf.text(dep.fullName || "", 20, y);
      pdf.text(dep.relationship || "", 60, y);
      pdf.text(dep.dateOfBirth || "", 100, y);
      pdf.text(dep.countryOfBirth || "", 130, y);
      pdf.text(dep.countryOfCitizenship || "", 165, y);
      y += lineHeight;
    });

    // Add extra space before drawing the line to avoid crowding
    y += 40;
    drawLine(8); // drawLine with more space
    y += 10; // more space after line

    addText("Section 3: Investment Details", true, 5);

  
  
    const drawTickOption = (checked, label) => {
      checkPageBreak();
      if (checked) {
        pdf.setFont("zapfdingbats");
        pdf.text(String.fromCharCode(51), 20, y); // ✓
      } else {
        pdf.setFont("helvetica", "normal");
        pdf.text("[ ]", 20, y);
      }
      pdf.setFont("helvetica", "normal");
      pdf.text(label, 30, y);
      y += lineHeight;
    };
  
    drawTickOption(investmentAmount === 800000, "$800,000 (Targeted Employment Area / Infrastructure Project)");
    drawTickOption(investmentAmount === 1050000, "$1,050,000 (Standard Minimum Investment)");
  
    // Start Section 4 on a new page
    drawLine();
    pdf.addPage();
    y = 20;
  
    addText("Section 4: Source of Funds - Breakdown", true, 5);
    pdf.setFont(undefined, "bold");
    pdf.text("Source", 20, y);
    pdf.text("Amount (USD)", 90, y);
    pdf.text("Docs?", 160, y);
    y += lineHeight;
    
    pdf.setFont(undefined, "normal");
    
    const fundSources = [
      "Personal Savings",
      "Employment Income",
      "Business Earnings",
      "Gift from Family/Friends",
      "Sale of Property or Assets",
      "Loan Proceeds",
      "Inheritance",
      "Crypto/Investment Gains",
      "Other",
    ];
    
    fundSources.forEach((sourceType) => {
      const source = sourceOfFunds.find((s) => s.sourceType === sourceType);
      const amount = source ? `$${source.amountUsd.toLocaleString()}` : "-";
    
      checkPageBreak();
      pdf.text(sourceType, 20, y);
      pdf.text(amount, 90, y);
    
      // Docs? column with ticks:
      if (source) {
        // Draw "Yes" checkbox
        pdf.setFont("zapfdingbats");
        if (source.supportingDocsAvailable) {
          pdf.text(String.fromCharCode(51), 160, y); // tick ✓
        } else {
          pdf.text(" ", 160, y); // empty
        }
    
        pdf.setFont("helvetica");
        pdf.text("Yes", 165, y);
    
        // Draw "No" checkbox
        pdf.setFont("zapfdingbats");
        if (!source.supportingDocsAvailable) {
          pdf.text(String.fromCharCode(51), 190, y); // tick ✓
        } else {
          pdf.text(" ", 190, y); // empty
        }
        pdf.setFont("helvetica");
        pdf.text("No", 195, y);
      } else {
        // No source data: empty checkboxes
        pdf.setFont("helvetica");
        pdf.text("[ ] Yes  [ ] No", 160, y);
      }
    
      y += lineHeight;
    });
    
    const total = sourceOfFunds.reduce((sum, s) => sum + (s.amountUsd || 0), 0);
    const totalText = sourceOfFunds.length
      ? `Total (must equal $800,000): $${total.toLocaleString()}`
      : "Total (must equal $800,000):";
    addText(totalText, false, 5);
    drawLine();

    
  
    addText("Section 5: Additional Notes / Explanations", true, 5);
    const note = additionalNote?.notes || "";
    const lines = pdf.splitTextToSize(note, 170);
    lines.forEach((line) => {
      checkPageBreak();
      pdf.text(line, 20, y);
      y += lineHeight;
    });
  
    pdf.save("EB5-Investor-Questionnaire.pdf");
  };
  



  // const handleDownload = async () => {
  //   if (!formRef.current) return;
  
  //   const backup = { ...formData };
  //   setFormData({ submitted: false });
  
  //   await new Promise((res) => setTimeout(res, 100));
  //   window.scrollTo(0, 0);
  
  //   formRef.current.querySelectorAll('[aria-expanded="false"]')?.forEach((el) => {
  //     el.click?.();
  //   });
  
  //   await new Promise((res) => setTimeout(res, 300));
  
  //   const canvas = await html2canvas(formRef.current, {
  //     scale: 2,
  //     useCORS: true,
  //     scrollY: -window.scrollY,
  //   });
  
  //   const imgHeight = canvas.height;
  //   const imgWidth = canvas.width;
  //   const imgData = canvas.toDataURL("image/png");
  
  //   const pdf = new jsPDF("p", "pt", "a4");
  //   const pdfWidth = pdf.internal.pageSize.getWidth();
  //   const pdfHeight = pdf.internal.pageSize.getHeight();
  
  //   const ratio = pdfWidth / imgWidth;
  //   const pageHeight = imgHeight * ratio;
  
  //   let position = 0;
  
  //   while (position < imgHeight) {
  //     const pageCanvas = document.createElement("canvas");
  //     pageCanvas.width = imgWidth;
  //     pageCanvas.height = Math.min(imgHeight - position, pdfHeight / ratio);
  
  //     const ctx = pageCanvas.getContext("2d");
  //     ctx?.drawImage(canvas, 0, position, imgWidth, pageCanvas.height, 0, 0, imgWidth, pageCanvas.height);
  
  //     const pageData = pageCanvas.toDataURL("image/png");
  
  //     if (position !== 0) pdf.addPage();
  //     pdf.addImage(pageData, "PNG", 0, 0, pdfWidth, pageCanvas.height * ratio);
  
  //     position += pageCanvas.height;
  //   }
  
  //   pdf.save("EB5-Intake-Form.pdf");
  
  //   // Restore form data
  //   setFormData(backup);
  // };
  

 
  

  // useEffect(() => {

  //   console.log(formData)

  // }, []);

  const validate = () => {
    const errors = {};

    // Section 1: Principal Applicant
    if (!formData.fullName?.trim()) errors.fullName = "Full name is required";
    if (!formData.dob) errors.dob = "Date of birth is required";
    if (!formData.birthCountry)
      errors.birthCountry = "Country of birth is required";
    if (!formData.citizenship) errors.citizenship = "Citizenship is required";
    if (!formData.immigrationStatus?.trim())
      errors.immigrationStatus = "Immigration status is required";
    if (!formData.passport?.trim())
      errors.passport = "Passport number is required";

    // Section 2: Dependents
    dependents.forEach((index) => {
      if (!formData[`depName${index}`]?.trim())
        errors[`depName${index}`] = "Dependent name is required";
      if (!formData[`depRelation${index}`]?.trim())
        errors[`depRelation${index}`] = "Relationship is required";
      if (!formData[`depDob${index}`])
        errors[`depDob${index}`] = "Date of birth is required";
      if (!formData[`depBirthCountry${index}`])
        errors[`depBirthCountry${index}`] = "Country of birth is required";
      if (!formData[`depCitizenship${index}`])
        errors[`depCitizenship${index}`] = "Citizenship is required";
    });

    // Section 3: Investment
    if (!formData.investmentAmount)
      errors.investmentAmount = "Please select an investment amount";

    // Section 4: Source of Funds
    let total = 0;
    for (let i = 0; i < 9; i++) {
      const val = Number(formData[`amount_${i}`] || 0);
      total += val;
      if (val && !formData[`support_${i}`]) {
        errors[`support_${i}`] =
          "Please select whether supporting documents are available.";
      }
    }

    if (total < 800000) {
      errors.totalFunds = "Total must be greater than or equal to $800,000";
    }

    // Section 5: Notes (optional, skip if not required)

    if (!formData.notes?.trim()) {
      errors.notes = "Please provide notes or explanation";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  useEffect(() => {
    if (getInitialDependentIndexes(initialData).length < dependents.length) {
      setDependentAdded(true);
    } else {
      setDependentAdded(false);
    }
  }, [dependents]);

  const addDependent = () => {
    const nextIndex = dependents.length > 0 ? Math.max(...dependents) + 1 : 0;
    setDependents([...dependents, nextIndex]);
    setAddedDependants([...addedDependants, nextIndex]);
  };


  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   console.log(formData)
  //   const payload = {
  //     id: formData.id, // profile ID from initialData
  //     invitationCodeId: sessionStorage.getItem("invitationCodeId"),
  //     fullLegalName: formData.fullName,
  //     dateOfBirth: formData.dob,
  //     countryOfBirth: formData.birthCountry,
  //     countryOfCitizenship: formData.citizenship,
  //     immigrationStatus: formData.immigrationStatus,
  //     passportNumber: formData.passport,
  //     investmentAmount: parseFloat(formData.investmentAmount)
  //   };

  //   fetch("http://localhost:13061/investorsProgram/createOrUpdateInvestor", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json"
  //     },
  //     body: JSON.stringify(payload)
  //   })
  //     .then((res) => {
  //       if (!res.ok) {
  //         throw new Error("Network response was not ok");
  //       }
  //       return res.json();
  //     })
  //     .then((data) => {
  //       console.log("Successfully submitted:", data);
  //       alert("Form submitted successfully!");
  //     })
  //     .catch((error) => {
  //       console.error("Error submitting form:", error);
  //       alert("There was an error submitting the form.");
  //     });
  // };

  const handleRemoveDependent = (index) => {
    if (dependents.length === 1) return;

    setDependents((prev) => prev.filter((idx) => idx !== index));
    setAddedDependants((prev) => prev.filter((idx) => idx !== index));

    // Clean up corresponding fields
    const updated = { ...formData };
    [
      `depId${index}`,
      `depName${index}`,
      `depRelation${index}`,
      `depDob${index}`,
      `depBirthCountry${index}`,
      `depCitizenship${index}`,
    ].forEach((key) => delete updated[key]);

    setFormData(updated);

    const removed = formData[`depId${index}`] ?? "";

    if (removed) {
      setRemovedDependents((prev) => [...prev, removed]);
    }
  };


  const handleSubmit = (e) => {
    e.preventDefault();
  
    if (!validate()) return;
  
    setLoading(true);
  
    const payload = {
      id: formData.id,
      invitationCodeId: sessionStorage.getItem("invitationCodeId"),
      fullLegalName: formData.fullName,
      dateOfBirth: formData.dob,
      countryOfBirth: formData.birthCountry,
      countryOfCitizenship: formData.citizenship,
      immigrationStatus: formData.immigrationStatus,
      passportNumber: formData.passport,
      investmentAmount: parseFloat(formData.investmentAmount),
    };
  
    const latestDependentIndex = dependents[dependents.length - 1];
    const latestDependent = {
      fullName: formData[`depName${latestDependentIndex}`],
      relationship: formData[`depRelation${latestDependentIndex}`],
      dateOfBirth: formData[`depDob${latestDependentIndex}`],
      countryOfBirth: formData[`depBirthCountry${latestDependentIndex}`],
      countryOfCitizenship: formData[`depCitizenship${latestDependentIndex}`],
    };
  
    const isDependentIncomplete = Object.values(latestDependent).some(
      (v) => !v?.trim()
    );
  
    if (dependentAdded && isDependentIncomplete) {
      alert("Please fill in all dependent fields.");
      return;
    }
  
    let finalInvestorId;
  
    axios
      .post("https://apiv1.worknotion.com/investorsProgram/createOrUpdateInvestor", payload)
      .then((investorResponse) => {
        console.log("Investor saved:", investorResponse.data);
  
        finalInvestorId = formData.id ?? investorResponse.data.id;
  
        return formData.id
          ? {
              res: axios.put(
                `https://apiv1.worknotion.com/investorsProgram/updateAdditionalNotes?id=${formData.id}`,
                {
                  investorProfileId: formData.id,
                  notes: formData.notes || "",
                }
              ),
              id: investorResponse.data.id,
            }
          : {
              res: axios.post(
                `https://apiv1.worknotion.com/investorsProgram/insertAdditionalNotes`,
                {
                  investorProfileId: investorResponse.data.id,
                  notes: formData.notes || "",
                }
              ),
              id: investorResponse.data.id,
            };
      })
      .then((notesResponse) => {
        console.log("Notes updated:", notesResponse.res.data);
  
        // === NEW: Insert/Update Source of Funds ===
        const sources = [
          "Personal Savings",
          "Employment Income",
          "Business Earnings",
          "Gift from Family/Friends",
          "Sale of Property or Assets",
          "Loan Proceeds",
          "Inheritance",
          "Crypto/Investment Gains",
          "Other",
        ];
  
        const apiCalls = sources.map((source, i) => {
          const amount = Number(formData[`amount_${i}`] || 0);
          const hasAmount = amount > 0;
          const supportingDocsAvailable = formData[`support_${i}`] === "Yes";
  
          if (!hasAmount) return null;
  
          const payload = {
            investorProfileId: finalInvestorId,
            sourceType: source,
            amountUsd: amount,
            supportingDocsAvailable,
          };
  
          // Updated logic: update if sourceOfFunds has matching sourceType with ID
          if (formData.id && Array.isArray(formData.sourceOfFunds)) {
            const matchingSource = formData.sourceOfFunds.find(
              (s) => s.sourceType === source
            );
  
            if (matchingSource?.id) {
              return axios.put(
                `https://apiv1.worknotion.com/investorsProgram/updateSourceOfFunds?id=${matchingSource.id}`,
                payload
              );
            }
          }
  
          // Else, insert new
          return axios.post(
            "https://apiv1.worknotion.com/investorsProgram/insertSourceOfFunds",
            payload
          );
        });
  
        return Promise.all(apiCalls.filter(Boolean)).then((res) => ({
          data: "Sources of funds processed",
          id: notesResponse.id,
        }));
      })
      .then((sourceFundsResponse) => {
        console.log("Source of funds handled:", sourceFundsResponse.data);
  
        let dependantsList = [];
  
        if (formData.id) {
          dependantsList = [...addedDependants];
        } else {
          dependantsList = [dependents[0], ...addedDependants];
        }
  
        if (dependantsList.length > 0) {
          return Promise.all(
            dependantsList.map((index) => {
              const latestDependent = {
                fullName: formData[`depName${index}`],
                relationship: formData[`depRelation${index}`],
                dateOfBirth: formData[`depDob${index}`],
                countryOfBirth: formData[`depBirthCountry${index}`],
                countryOfCitizenship: formData[`depCitizenship${index}`],
              };
  
              const isLatestDependentFilled =
                latestDependent.fullName?.trim() &&
                latestDependent.relationship?.trim() &&
                latestDependent.dateOfBirth &&
                latestDependent.countryOfBirth?.trim() &&
                latestDependent.countryOfCitizenship?.trim();
  
              const isLatestDependentIncomplete =
                latestDependent.fullName?.trim() ||
                latestDependent.relationship?.trim() ||
                latestDependent.dateOfBirth ||
                latestDependent.countryOfBirth?.trim() ||
                latestDependent.countryOfCitizenship?.trim();
  
              if (isLatestDependentIncomplete && !isLatestDependentFilled) {
                alert("Please fill in all dependent fields.");
                return;
              }
  
              if (isLatestDependentFilled) {
                return axios.post(
                  `https://apiv1.worknotion.com/investorsProgram/addDependents?InvestorProfileId=${
                    formData.id ?? sourceFundsResponse.id
                  }`,
                  [latestDependent]
                );
              }
            })
          );
        }
  
        return Promise.resolve({ data: "No valid new dependents to add." });
      })
      .then((dependentsResponse) => {
        console.log("Dependents added:", dependentsResponse.data);
  
        if (formData.id && updatedDependents.length > 0) {
          return Promise.all(
            updatedDependents.map((dep) => {
              if (formData[`depId${dep}`]) {
                return axios.put(
                  `https://apiv1.worknotion.com/investorsProgram/updateInvestorDependent?id=${formData[`depId${dep}`]}`,
                  {
                    investorProfileId: formData.id,
                    fullName: formData[`depName${dep}`],
                    relationship: formData[`depRelation${dep}`],
                    dateOfBirth: formData[`depDob${dep}`],
                    countryOfBirth: formData[`depBirthCountry${dep}`],
                    countryOfCitizenship: formData[`depCitizenship${dep}`],
                  }
                );
              }
            })
          );
        } else {
          return Promise.resolve({ data: "No dependents to update." });
        }
      })
      .then((updatedResponse) => {
        console.log("Dependents Updated:", updatedResponse.data);
  
        if (removedDependents.length > 0) {
          return Promise.all(
            removedDependents.map((dep) =>
              axios.delete(
                `https://apiv1.worknotion.com/investorsProgram/deleteInvestorDependent?id=${dep}`
              )
            )
          );
        } else {
          return Promise.resolve({ data: "No dependents to delete." });
        }
      })
      .then((deleteResponse) => {
        console.log("Dependents deleted (if any):", deleteResponse.data);
        setLoading(false);
        alert("Form submitted successfully, including dependents and source of funds!");
      })
      .catch((error) => {
        console.error("Submission error:", error);
        setLoading(false);
        alert("There was an error submitting the form.");
      });
  };
  

  

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   if (!validate()) return;

  //   setLoading(true);

  //   const payload = {
  //     id: formData.id,
  //     invitationCodeId: sessionStorage.getItem("invitationCodeId"),
  //     fullLegalName: formData.fullName,
  //     dateOfBirth: formData.dob,
  //     countryOfBirth: formData.birthCountry,
  //     countryOfCitizenship: formData.citizenship,
  //     immigrationStatus: formData.immigrationStatus,
  //     passportNumber: formData.passport,
  //     investmentAmount: parseFloat(formData.investmentAmount),
  //   };

  //   const latestDependentIndex = dependents[dependents.length - 1];
  //   const latestDependent = {
  //     fullName: formData[`depName${latestDependentIndex}`],
  //     relationship: formData[`depRelation${latestDependentIndex}`],
  //     dateOfBirth: formData[`depDob${latestDependentIndex}`],
  //     countryOfBirth: formData[`depBirthCountry${latestDependentIndex}`],
  //     countryOfCitizenship: formData[`depCitizenship${latestDependentIndex}`],
  //   };

  //   const isDependentIncomplete = Object.values(latestDependent).some(
  //     (v) => !v?.trim()
  //   );

  //   if (dependentAdded && isDependentIncomplete) {
  //     alert("Please fill in all dependent fields.");
  //     return;
  //   }

  //   let finalInvestorId;

  //   axios
  //     .post(
  //       "http://localhost:13061/investorsProgram/createOrUpdateInvestor",
  //       payload
  //     )
  //     .then((investorResponse) => {
  //       console.log("Investor saved:", investorResponse.data);

  //       finalInvestorId = formData.id ?? investorResponse.data.id;

  //       return formData.id
  //         ? {
  //             res: axios.put(
  //               `http://localhost:13061/investorsProgram/updateAdditionalNotes?id=${formData.id}`,
  //               {
  //                 investorProfileId: formData.id,
  //                 notes: formData.notes || "",
  //               }
  //             ),
  //             id: investorResponse.data.id,
  //           }
  //         : {
  //             res: axios.post(
  //               `http://localhost:13061/investorsProgram/insertAdditionalNotes`,
  //               {
  //                 investorProfileId: investorResponse.data.id,
  //                 notes: formData.notes || "",
  //               }
  //             ),
  //             id: investorResponse.data.id,
  //           };
  //     })
  //     .then((notesResponse) => {
  //       console.log("Notes updated:", notesResponse.res.data);
  //       let dependantsList=[];
        
  //       if(formData.id) {
  //         dependantsList=[...addedDependants]
  //       } else {
  //         dependantsList=[dependents[0], ...addedDependants]
  //       }
        
  //       if(dependantsList.length>0) {
  //         return Promise.all(
  //           dependantsList.map((index) => {
  //             // Prepare latest dependent data
  //             const latestDependent = {
  //               fullName: formData[`depName${index}`],
  //               relationship: formData[`depRelation${index}`],
  //               dateOfBirth: formData[`depDob${index}`],
  //               countryOfBirth: formData[`depBirthCountry${index}`],
  //               countryOfCitizenship:
  //                 formData[`depCitizenship${index}`],
  //             };
    
  //             // Check if all fields are filled (dependent is valid)
  //             const isLatestDependentFilled =
  //               latestDependent.fullName?.trim() &&
  //               latestDependent.relationship?.trim() &&
  //               latestDependent.dateOfBirth &&
  //               latestDependent.countryOfBirth?.trim() &&
  //               latestDependent.countryOfCitizenship?.trim();
    
  //             // Check if any field is filled (but not all)
  //             const isLatestDependentIncomplete =
  //               latestDependent.fullName?.trim() ||
  //               latestDependent.relationship?.trim() ||
  //               latestDependent.dateOfBirth ||
  //               latestDependent.countryOfBirth?.trim() ||
  //               latestDependent.countryOfCitizenship?.trim();
    
  //             // If partially filled, show alert
  //             if (isLatestDependentIncomplete && !isLatestDependentFilled) {
  //               alert("Please fill in all dependent fields.");
  //               return;
  //             }
    
  //             // If all fields are filled, submit dependent
  //             if (isLatestDependentFilled) {
  //               return axios.post(
  //                 `http://localhost:13061/investorsProgram/addDependents?InvestorProfileId=${
  //                   formData.id ?? notesResponse.id
  //                 }`,
  //                 [latestDependent]
  //               );
  //             }
  //           })
  //         );    
  //       }    

  //       return Promise.resolve({ data: "No valid new dependents to add." });
  //     })
  //     .then((dependentsResponse) => {
  //       console.log("Dependents added:", dependentsResponse.data);

  //       console.log(updatedDependents, "uuuuuuuuuuuuu");

  //       if (formData.id && updatedDependents.length > 0) {
  //         return Promise.all(
  //           updatedDependents.map((dep) => {
  //             if (formData[`depId${dep}`]) {
  //               return axios.put(
  //                 `http://localhost:13061/investorsProgram/updateInvestorDependent?id=${
  //                   formData[`depId${dep}`]
  //                 }`,
  //                 {
  //                   investorProfileId: formData.id,
  //                   fullName: formData[`depName${dep}`],
  //                   relationship: formData[`depRelation${dep}`],
  //                   dateOfBirth: formData[`depDob${dep}`],
  //                   countryOfBirth: formData[`depBirthCountry${dep}`],
  //                   countryOfCitizenship: formData[`depCitizenship${dep}`],
  //                 }
  //               );
  //             }
  //           })
  //         );
  //       } else {
  //         return Promise.resolve({ data: "No dependents to update." });
  //       }
  //     })
  //     .then((updatedResponse) => {
  //       console.log("Dependents Updated:", updatedResponse.data);

  //       // Delete removed dependents
  //       if (removedDependents.length > 0) {
  //         return Promise.all(
  //           removedDependents.map((dep) =>
  //             axios.delete(
  //               `http://localhost:13061/investorsProgram/deleteInvestorDependent?id=${dep}`
  //             )
  //           )
  //         );
  //       } else {
  //         return Promise.resolve({ data: "No dependents to delete." });
  //       }
  //     })
  //     .then((deleteResponse) => {
  //       console.log("Dependents deleted (if any):", deleteResponse.data);
  //       setLoading(false); // Hide loader
  //       alert("Form submitted successfully, including dependents and notes!");
  //     })
  //     .catch((error) => {
  //       console.error("Submission error:", error);
  //       setLoading(false); // Hide loader
  //       alert("There was an error submitting the form.");
  //     });
  // };

 

  return (
    <Form ref={formRef} onSubmit={handleSubmit} id="printableForm" className="p-4 container">
      <h2 className="text-center formHeading mb-5 p-4">
        EB-5 Investor Intake Form
      </h2>

      {formData.submitted === true && (
        <div className="alert alert-info text-center">
          The form is in read-only mode. If you want any changes, contact admin.
        </div>
      )}

      {/* Section 1 */}
      <Card className="mb-4 shadow formBg p-4">
        <Card.Body>
          <Card.Title className="mb-4">
            Section 1: Principal Applicant Information
          </Card.Title>
          <Row>
            {[
              ["Full Legal Name", "fullName"],
              ["Date of Birth", "dob", "date"],
              ["Country of Birth", "birthCountry"],
              ["Country of Citizenship", "citizenship"],
              ["Current Immigration Status (U.S.)", "immigrationStatus"],
              ["Passport Number", "passport"],
            ].map(([label, key, type = "text"], idx) => (
              <Col md={6} key={idx}>
                <Form.Group className="mb-3">
                  <Form.Label>{label}</Form.Label>
                  {key === "birthCountry" || key === "citizenship" ? (
                    <>
                      <Form.Select
                        value={formData[key] || ""}
                        onChange={(e) => handleChange(key, e.target.value)}
                        isInvalid={!!formErrors[key]}
                        disabled={formData.submitted === true}
                      >
                        <option value="">Select Country</option>
                        <option value="USA">USA</option>
                        <option value="India">India</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {formErrors[key]}
                      </Form.Control.Feedback>
                    </>
                  ) : (
                    <>
                      <Form.Control
                        type={type}
                        value={formData[key] || ""}
                        onChange={(e) => handleChange(key, e.target.value)}
                        isInvalid={!!formErrors[key]}
                        disabled={formData.submitted === true}
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors[key]}
                      </Form.Control.Feedback>
                    </>
                  )}
                </Form.Group>
              </Col>
            ))}
          </Row>
        </Card.Body>
      </Card>

      {/* Section 2 */}
      <Card className="mb-4 shadow formBg p-4">
        <Card.Body>
          <Card.Title className="mb-4">
            Section 2: Dependents Information
          </Card.Title>
          {dependents.map((index) => (
            <Row key={index} className="mb-3 align-items-end">
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    value={formData[`depName${index}`] || ""}
                    onChange={(e) =>
                      handleChange(`depName${index}`, e.target.value, index)
                    }
                    isInvalid={!!formErrors[`depName${index}`]}
                    disabled={formData.submitted === true}
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors[`depName${index}`]}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={2}>
                <Form.Group>
                  <Form.Label>Relationship</Form.Label>
                  <Form.Control
                    value={formData[`depRelation${index}`] || ""}
                    onChange={(e) =>
                      handleChange(`depRelation${index}`, e.target.value, index)
                    }
                    isInvalid={!!formErrors[`depRelation${index}`]}
                    disabled={formData.submitted === true}
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors[`depRelation${index}`]}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={2}>
                <Form.Group>
                  <Form.Label>Date of Birth</Form.Label>
                  <Form.Control
                    type="date"
                    value={formData[`depDob${index}`] || ""}
                    onChange={(e) =>
                      handleChange(`depDob${index}`, e.target.value, index)
                    }
                    isInvalid={!!formErrors[`depDob${index}`]}
                    disabled={formData.submitted === true}
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors[`depDob${index}`]}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={2}>
                <Form.Group>
                  <Form.Label>Country of Birth</Form.Label>
                  <Form.Select
                    value={formData[`depBirthCountry${index}`] || ""}
                    onChange={(e) =>
                      handleChange(
                        `depBirthCountry${index}`,
                        e.target.value,
                        index
                      )
                    }
                    isInvalid={!!formErrors[`depBirthCountry${index}`]}
                    disabled={formData.submitted === true}
                  >
                    <option value="">Select Country</option>
                    <option value="USA">USA</option>
                    <option value="India">India</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {formErrors[`depBirthCountry${index}`]}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={2}>
                <Form.Group>
                  <Form.Label>Country of Citizenship</Form.Label>
                  <Form.Select
                    value={formData[`depCitizenship${index}`] || ""}
                    onChange={(e) =>
                      handleChange(
                        `depCitizenship${index}`,
                        e.target.value,
                        index
                      )
                    }
                    isInvalid={!!formErrors[`depCitizenship${index}`]}
                    disabled={formData.submitted === true}
                  >
                    <option value="">Select Country</option>
                    <option value="USA">USA</option>
                    <option value="India">India</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {formErrors[`depCitizenship${index}`]}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={2} className="text-end">
                <Button
                  variant="danger"
                  onClick={() => handleRemoveDependent(index)}
                  disabled={
                    dependents.length === 1 || formData.submitted === true
                  }
                  className="mt-2"
                >
                  Remove
                </Button>
              </Col>
            </Row>
          ))}

          <Button
            variant="outline-primary"
            onClick={addDependent}
            disabled={formData.submitted === true}
          >
            + Add Dependent
          </Button>
        </Card.Body>
      </Card>

      {/* Section 3 */}
      <Card className="mb-4 shadow formBg p-4">
        <Card.Body>
          <Card.Title className="mb-4">
            Section 3: Investment Details
          </Card.Title>

          <Form.Group>
            <Form.Check
              label="$800,000 (Targeted Employment Area / Infrastructure Project)"
              name="investmentAmount"
              type="radio"
              value="800000"
              checked={formData.investmentAmount === "800000"}
              onChange={(e) => handleChange("investmentAmount", e.target.value)}
              isInvalid={!!formErrors.investmentAmount}
              disabled={formData.submitted === true}
            />
            <Form.Check
              label="$1,050,000 (Standard Minimum Investment)"
              name="investmentAmount"
              type="radio"
              value="1050000"
              checked={formData.investmentAmount === "1050000"}
              onChange={(e) => handleChange("investmentAmount", e.target.value)}
              isInvalid={!!formErrors.investmentAmount}
              disabled={formData.submitted === true}
            />
            {formErrors.investmentAmount && (
              <div className="invalid-feedback d-block">
                {formErrors.investmentAmount}
              </div>
            )}
          </Form.Group>
        </Card.Body>
      </Card>

      {/* Section 4 */}
      <Card className="mb-4 shadow formBg p-4">
        <Card.Body>
          <Card.Title className="mb-4">
            Section 4: Source of Funds - Breakdown
          </Card.Title>

          {[
            "Personal Savings",
            "Employment Income",
            "Business Earnings",
            "Gift from Family/Friends",
            "Sale of Property or Assets",
            "Loan Proceeds",
            "Inheritance",
            "Crypto/Investment Gains",
            "Other",
          ].map((source, i) => (
            <Row key={i} className="mb-2">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>{source}</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Amount (USD)"
                    value={formData[`amount_${i}`] || ""}
                    onChange={(e) =>
                      handleChange(`amount_${i}`, e.target.value)
                    }
                    disabled={formData.submitted === true}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Supporting Docs</Form.Label>
                  <Form.Select
                    value={formData[`support_${i}`] || "No"}
                    onChange={(e) =>
                      handleChange(`support_${i}`, e.target.value)
                    }
                    isInvalid={!!formErrors[`support_${i}`]}
                    disabled={formData.submitted === true}
                  >
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Select>
                  {formErrors[`support_${i}`] && (
                    <Form.Control.Feedback type="invalid">
                      {formErrors[`support_${i}`]}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              </Col>
            </Row>
          ))}

          <Form.Group className="mt-3">
            <Form.Label>Total (must equal $800,000)</Form.Label>
            <Form.Control
  type="number"
  value={
    Array.from({ length: 9 }).reduce(
      (acc, _, i) => acc + Number(formData[`amount_${i}`] || 0),
      0
    )
  }
  readOnly
  isInvalid={!!formErrors.totalFunds}
  disabled={formData.submitted === true}
/>
            {formErrors.totalFunds && (
              <Form.Control.Feedback type="invalid">
                {formErrors.totalFunds}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Card.Body>
      </Card>

      {/* Section 5 */}
      <Card className="mb-5 shadow formBg p-4">
        <Card.Body>
          <Card.Title className="mb-3">
            Section 5: Additional Notes / Explanations
          </Card.Title>
          <Form.Group>
            <Form.Control
              as="textarea"
              rows={4}
              value={formData.notes || ""}
              onChange={(e) => handleChange("notes", e.target.value)}
              disabled={formData.submitted === true}
              placeholder="Add any explanations or special notes here..."
              isInvalid={!!formErrors.notes}
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.notes}
            </Form.Control.Feedback>
          </Form.Group>
        </Card.Body>
      </Card>

      {/* Submit Button */}
      <div className="text-center d-flex justify-content-center gap-3">
  {/* Download PDF Button */}
  <Button
    variant="primary"
    onClick={handleGenerateStyledPDF}
    disabled={loading}
  >
    Download Investor PDF
  </Button>

  {/* Submit Button */}
  <Button
    variant="success"
    type="submit"
    size="lg"
    disabled={formData.submitted === true || loading}
  >
    {loading ? (
      <>
        <Spinner
          as="span"
          animation="border"
          className="me-2"
          size="sm"
          role="status"
          aria-hidden="true"
        />{" "}
        Submitting...
      </>
    ) : (
      "Submit Form"
    )}
  </Button>
</div>

    </Form>
  );
}

export default InvestorForm;
